module.exports = __webpack_public_path__ + "img/penqi2.7cc3de40.jpg";